<template>
  <div v-if="tokenValid" class="registration-form password-form">
    <validation-observer ref="resetPassObs"
                         tag="form"
                         @submit.prevent="submitResetPassword">
      <div class="form-fields">
        <validate-password-dropdown
          :visible="passwordFieldFocused"
          :password="passwordInput">
          <base-v-input v-model.trim="passwordInput"
                        id="newPassword"
                        container-class="password-input"
                        name="newPassword"
                        rules="required|password"
                        @focus="passwordFieldFocused = true"
                        @blur="passwordFieldFocused = false"
                        :submitted="resetPasswordSubmitted"
                        :label="$t('registration.newPasswordLabel')"
                        revealPassword
                        type="password"
                        maxlength="20"
                        vid="password"
                        ref="password"/>
        </validate-password-dropdown>
        <base-v-input v-model.trim="confirmPasswordInput"
                      id="confirmPassword"
                      container-class="password-input"
                      name="confirmPassword"
                      rules="required|confirmPassword:@password"
                      :submitted="resetPasswordSubmitted"
                      :label="$t('registration.confirmPasswordLabel')"
                      revealPassword
                      type="password"
                      maxlength="20"
                      vid="confirmPassword"/>
      </div>
      <base-button :disabled="!resetPasswordFormFilled" :loading="dataLoading" class="reset-btn"
                   type="submit">
        {{ $t('common.save') }}
      </base-button>
    </validation-observer>
  </div>
</template>

<script>

import { parseQueryString } from '@/utils/queryParser'
import ValidatePasswordDropdown from '@/components/common/validate-password-dropdown'
import { customRouter } from '@/customRouter'

export default {
  name: 'reset-password-form',
  components: { ValidatePasswordDropdown },
  data () {
    return {
      passwordInput: '',
      confirmPasswordInput: '',
      token: '',
      userId: '',
      resetPasswordSubmitted: false,
      dataLoading: false,
      passwordFieldFocused: false,
      tokenValid: false

    }
  },
  computed: {
    resetPasswordFormFilled () {
      return !!this.passwordInput && !!this.confirmPasswordInput
    }
  },
  methods: {
    checkToken (token) {
      this.$apiRequest.post('user/password/token', { token: token })
        .then(response => {
          if (response.status >= 200 && response.status < 400) {
            this.tokenValid = true
          }
        })
        .catch(e => {
          customRouter.goTo({ name: 'resetPasswordExpiredLink' })
        })
        .finally(() => {
          this.$loader.hide()
        })
    },
    sendApiRequest () {
      this.dataLoading = true
      this.$apiRequest.put('user/password/reset', { newPassword: this.passwordInput, token: this.token })
        .then(response => {
          if (response.status >= 200 && response.status < 400) {
            customRouter.goTo({ name: 'resetPasswordConfirmation' })
          }
        })
        .catch(e => {
          if (e.response.data.errors && e.response.data.errors.length) {
            this.toast('error', {
              message: e.response.data.errors[0].message || this.$t('errors.defaultError')
            })
          } else {
            this.toast('error', {
              message: this.$t('errors.serverError')
            })
          }
          this.dataLoading = false
        })
    },
    async submitResetPassword () {
      this.resetPasswordSubmitted = true
      const valid = await this.$refs.resetPassObs.validate()
      if (valid) {
        this.sendApiRequest()
      } else {
        this.dataLoading = false
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$loader.show(' ')
      const qs = parseQueryString()
      if (qs && qs.token && qs.userId) {
        this.token = decodeURIComponent(qs.token)
        this.userId = decodeURIComponent(qs.userId)
        this.checkToken(decodeURIComponent(qs.token))
      } else {
        customRouter.goTo({ name: 'resetPasswordExpiredLink' })
      }
    })
  }

}
</script>

<style scoped lang="scss" src="../registration/registration-comp-styles/registration-form.scss"></style>
